import { jsxs as r, jsx as e } from "@emotion/react/jsx-runtime";
import { useState as c } from "react";
import { Stack as p, Icon as d, FontAwesomeIconsPartooUsed as i, IconPrefix as s, Expandable as l } from "@partoohub/ui";
import { StyledStack as m, EllipsisText as f, ExpandableContainer as h } from "./Section.styled.js";
import { Group as g } from "./Group/Group.js";
const b = ({
  section: n
}) => {
  const [t, a] = c(!0);
  return /* @__PURE__ */ r(p, { gap: "0px", children: [
    /* @__PURE__ */ r(m, { onClick: () => a((o) => !o), justifyContent: "space-between", direction: "row", alignItems: "center", children: [
      /* @__PURE__ */ e(f, { variant: "heading6", children: n.name }),
      /* @__PURE__ */ e(d, { icon: [t ? i.faChevronDown : i.faChevronRight, s.SOLID] })
    ] }),
    /* @__PURE__ */ e(l, { opened: t, children: /* @__PURE__ */ e(h, { children: n.groups.map((o) => /* @__PURE__ */ e(g, { group: o }, o.id)) }) }, n.id)
  ] });
};
export {
  b as Section
};
